<template>
	<div
		role="dialog"
		@click.stop
		class="absolute overflow-hidden"
		:class="{
			'rounded-4': isSimple,
			'dialog-bottom-sheet rounded-t-4': isBottomSheet,
			'bg-white': !emptyDialog,
		}"
		style="pointer-events: auto"
	>
		<div
			class="d-flex flex-column confirmation-dialog"
			:class="{
				[`size-${size}`]: isSimple,
				'full-size': isFullSize,
				'auto-height': autoHeight,
			}"
		>
			<slot name="header" />
			<slot />
			<slot name="actions" />
		</div>
	</div>
</template>

<script setup lang="ts">
	import { DialogSize } from './dialogTypes'

	interface Props {
		size?: DialogSize
		isSimple?: boolean
		isFullSize?: boolean
		isBottomSheet?: boolean
		autoHeight?: boolean
		emptyDialog?: boolean
	}

	withDefaults(defineProps<Props>(), {
		size: 'm',
		autoHeight: false,
	})
</script>

<style scoped>
	.confirmation-dialog {
		box-shadow: 0 0 12px rgba(183, 183, 183, 0.08);
	}

	.size-xs {
		width: 340px;
		max-width: 95vw;
		max-height: 95dvh;
	}

	.size-s {
		width: 558px;
		max-width: 95vw;
		min-height: 100px;
		max-height: 95dvh;
	}

	.size-m {
		width: 780px;
		max-width: 95vw;
		min-height: 100px;
		max-height: 95dvh;
	}

	.size-l {
		width: 90vw;
		max-width: 95vw;
		min-height: 80dvh;
		max-height: 95dvh;
	}

	.full-size {
		width: 100vw;
		height: 100dvh;
		overflow: auto;
	}

	.auto-height {
		min-height: auto;
		max-height: none;
		height: auto;
	}

	.dialog-bottom-sheet {
		width: 100vw;
		bottom: 0;
	}
</style>
